import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Label from 'src/components/_utility/Label';
import GridView from 'src/assets/icons/grid-view.svg';
import ListView from 'src/assets/icons/list-view.svg';
import { getBikesView, getBikesSort } from 'src/redux/bikes/selectors';
import { setView, setSort } from 'src/redux/bikes/actions';
import ArrowDown from 'src/assets/icons/arrow-down.svg';
import sortOptions from 'src/config/sortOptions.config';
import useLabel from 'src/hooks/useLabel';
import { sendGaEvent } from 'helpers/analytics';
import { getViewportWidth } from 'helpers/utilities';
import theme from 'src/lib/theme';
import { ViewWrap, IconWrap, LabelWrap, SelectWrap, Select } from './ViewAndSort.styled';

const ViewAndSort = ({ viewHidden }) => {
  const dispatch = useDispatch();
  const bikeView = useSelector(getBikesView);
  const sortValue = useSelector(getBikesSort);
  const getLabel = useLabel();

  useEffect(() => {
    const setToGrid = () => {
      if (getViewportWidth() < theme.breakpoints.tabletLarge) {
        dispatch(setView('grid'));
      }
    };

    window.addEventListener('resize', setToGrid);

    return () => window.removeEventListener('resize', setToGrid);
  }, []);

  return (
    <>
      <ViewWrap>
        {!viewHidden ? (
          <>
            <LabelWrap>
              <Label name="viewLabel" />
            </LabelWrap>
            <IconWrap
              active={bikeView === 'grid'}
              onClick={() => [dispatch(setView('grid')), sendGaEvent('View', 'Grid')]}
            >
              <GridView />
            </IconWrap>
            <IconWrap
              active={bikeView === 'list'}
              onClick={() => [dispatch(setView('list')), sendGaEvent('View', 'List')]}
            >
              <ListView />
            </IconWrap>
          </>
        ) : null}
      </ViewWrap>
      <SelectWrap>
        <Select
          tabIndex="0"
          value={sortValue}
          onChange={event => [dispatch(setSort(event.target.value)), sendGaEvent('Sort By', event.target.value)]}
        >
          <option value="" disabled>
            {getLabel('sortByLabel')}
          </option>
          {sortOptions.map(sortOption => (
            <option key={sortOption.id} value={sortOption.id}>
              {getLabel(sortOption.label)}
            </option>
          ))}
        </Select>
        <ArrowDown />
      </SelectWrap>
    </>
  );
};

export default ViewAndSort;
